import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { Repository } from "typeorm";
import { Application } from "../src/app/entity/application.entity";
import { ApplicationModel } from "./model/application.model";
import { ApplicationResponse } from "./model/application-response.model";

@Injectable()
export class ApplicationService {
  constructor(
    @InjectRepository(Application) private applicationRepo: Repository<Application>, 
  ) {}

  async addApplications(createapplication: ApplicationModel): Promise<ApplicationResponse> {
    try {
      const applicationobj = new Application();
      applicationobj.companyName = createapplication.companyName;
      applicationobj.moduleName = createapplication.moduleName;

      console.log(applicationobj);

      await this.applicationRepo.save(applicationobj);

      return new ApplicationResponse(true, 201, 'Application created successfully', [createapplication]);
    } catch (error) {
      console.log("Error occurred while creating applications:", error.message);
      return new ApplicationResponse(false, 500, 'Failed to create application', []);
    }
  }

  async getallApplications(): Promise<ApplicationResponse> {
    try {
      const data = await this.applicationRepo.find();
      return new ApplicationResponse(true, 200, 'Applications retrieved successfully', data);
    } catch (error) {
      console.log("Error occurred while getting applications:", error.message);
      return new ApplicationResponse(false, 500, 'Failed to retrieve applications', []);
    }
  }
}
